import { g as getRecentlyViewedProducts, i as isPreferencesAllowed } from './app-chunk-utils-S2wKFyPJ.js';

if (!customElements.get("product-recs")) {
  class ProductRecs extends HTMLElement {
    constructor() {
      super();

      /** @type {NodeListOf<HTMLButtonElement>} */
      this.tabButtons = this.querySelectorAll(".pdp-recs__tab");

      /** @type {NodeListOf<HTMLButtonElement>} */
      this.tabPanels = this.querySelectorAll(".pdp-recs__tab-content");

      this.handleConsentChange = this.handleConsentChange.bind(this);
      this.recentlyViewedLoaded = false;
    }

    connectedCallback() {
      this.addEventListener("in-view", this.handleInView.bind(this));
      this.tabButtons.forEach((btn) => {
        btn.addEventListener("click", this.handleTabClick.bind(this));
      });

      document.addEventListener(
        "visitorConsentCollected",
        this.handleConsentChange
      );

      this.updateRecentlyViewedVisibility();
    }

    disconnectedCallback() {
      document.removeEventListener(
        "visitorConsentCollected",
        this.handleConsentChange
      );
    }

    setSegmentValues() {
      const recommendedProducts = this.querySelectorAll(
        '.pdp-recs__tab-content[data-tab="recommended"] [data-product-scope]'
      );

      const recentlyViewedProducts = this.querySelectorAll(
        '.pdp-recs__tab-content[data-tab="recently-viewed"] [data-product-scope]'
      );

      recommendedProducts.forEach((card) => {
        card.setAttribute("data-source", "You May Also Like");
        card.setAttribute("data-category", "quickshop");
      });

      recentlyViewedProducts.forEach((card) => {
        card.setAttribute("data-source", "Recently Viewed");
        card.setAttribute("data-category", "quickshop");
      });
    }

    handleConsentChange() {
      this.updateRecentlyViewedVisibility();
    }

    async updateRecentlyViewedVisibility() {
      const productId = Number(this.getAttribute("product-id"));
      const viewdedInfo = getRecentlyViewedProducts(productId);
      const allowed = await isPreferencesAllowed();

      if (allowed && viewdedInfo.length >= 3) {
        this.tabButtons[1].style.display = "";
      } else {
        this.tabButtons[0].setAttribute("aria-selected", "true");
        this.tabButtons[1].setAttribute("aria-selected", "false");
        this.tabButtons[1].style.display = "none";
      }
    }

    /**
     * @param {number} ms
     */
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    isReducedMotion() {
      return (
        window.matchMedia("(prefers-reduced-motion: reduce)").matches === true
      );
    }

    /**
     * @param {MouseEvent} e
     */
    handleTabClick(e) {
      /** @type {HTMLButtonElement} */
      // @ts-ignore
      const activeBtn = e.currentTarget;

      this.tabButtons.forEach((btn) => {
        if (btn === activeBtn) {
          btn.setAttribute("aria-selected", "true");
        } else {
          btn.setAttribute("aria-selected", "false");
        }
      });

      const controls = activeBtn.getAttribute("aria-controls");

      this.tabPanels.forEach((panel) => {
        if (panel.id === controls) {
          panel.removeAttribute("hidden");
          if (panel.dataset.tab === "recently-viewed") ;
        } else {
          panel.setAttribute("hidden", "true");
        }
      });

      this.renderRecentlyViewed();
    }

    /**
     * @param {HTMLElement} tabPanel
     */
    showProductCards(tabPanel) {
      this.setSegmentValues();
      const products = tabPanel.querySelectorAll(".pdp-recs__product");
      if (this.isReducedMotion()) {
        for (const product of products) {
          product.setAttribute("data-state", "ready");
        }
        return;
      }

      window.setTimeout(async () => {
        for (const product of products) {
          product.setAttribute("data-state", "ready");
          await this.delay(180);
        }
      }, 50);

      window.yotpoWidgetsContainer.initWidgets(false);
    }

    async handleInView() {
      const sectionId = this.getAttribute("section-id");
      const productId = this.getAttribute("product-id");
      const intent = this.getAttribute("intent");

      /** @type {HTMLElement} */
      // @ts-expect-error
      const tabPanel = this.querySelector("[data-tab='recommended']");

      /** @type {HTMLElement} */
      // @ts-ignore
      const container = tabPanel.querySelector(".pdp-recs__tab-products");

      const resp = await fetch(
        `/recommendations/products?limit=3&product_id=${productId}&section_id=${sectionId}&intent=${intent}`
      );

      const html = await resp.text();
      const element = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".pdp-recs__tab-products");

      if (!element) {
        console.error("Could not find element for product recs");
        return;
      }

      container.innerHTML = element.innerHTML;
      this.showProductCards(container);
    }

    async renderRecentlyViewed() {
      if (this.recentlyViewedLoaded === true) {
        return;
      }

      this.recentlyViewedLoaded = true;

      const productId = Number(this.getAttribute("product-id"));
      const viewdedInfo = getRecentlyViewedProducts(productId);

      /** @type {HTMLElement} */
      // @ts-expect-error
      const tabPanel = this.querySelector("[data-tab='recently-viewed']");

      /** @type {HTMLElement} */
      // @ts-expect-error
      const container = tabPanel.querySelector(".pdp-recs__tab-products");

      const stub = document.createElement("div");
      const parser = new DOMParser();

      for (const info of viewdedInfo) {
        const res = await fetch(
          `/products/${info.handle}?variant=${info.variantId}&section_id=pdp-recently-viewed-product`
        );
        const html = await res.text();

        /** @type {HTMLElement} */
        // @ts-expect-error
        const card = parser
          .parseFromString(html, "text/html")
          .querySelector(".shopify-section");

        stub.appendChild(card);
      }

      container.innerHTML = stub.innerHTML;
      this.showProductCards(container);
    }
  }

  customElements.define("product-recs", ProductRecs);
}
